import React from 'react';
import { Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';

import { DevExTheme, useDevExTheme } from 'jf/common/themes/DevExTheme';

import { DevExSkeleton } from './DevExSkeleton';

type DevExTextProps = {
  fontSize?: keyof DevExTheme['variable']['fontSize'];
  fontFamily?: keyof DevExTheme['variable']['fontFamily'];
  type?: 'primary' | 'secondary' | 'tertiary';
  loading?: boolean;
  loadingWidth?: string | number;
  lined?: boolean;
  ellipsis?: boolean;
  title?: string;
} & Pick<TextProps, 'editable' | 'strong' | 'italic' | 'style'>;

const { Text } = Typography;

export const DevExText: React.FC<DevExTextProps> = (props) => {
  const theme = useDevExTheme();

  const fontSize = props.fontSize ?? 'sm';
  const fontFamily = props.fontFamily ?? 'primary';
  const type = props.type ?? 'primary';

  if (props.loading) {
    return (
      <DevExSkeleton
        fontSize={props.fontSize}
        width={props.loadingWidth}
        noLineHeight={!props.lined}
      />
    );
  }
  return (
    <Text
      style={{
        fontSize: theme.variable.fontSize[fontSize],
        fontFamily: theme.variable.fontFamily[fontFamily],
        color: theme.color.text[type],
        fontWeight: props.strong ? 600 : 400,
        fontStyle: props.italic ? 'italic' : 'normal',
        lineHeight: props.lined ? theme.variable.lineHeight : 1,
        ...(props.ellipsis
          ? { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
          : {}),
        ...props.style,
      }}
      editable={props.editable}
      data-cy={props['data-cy']}
    >
      {props.children}
    </Text>
  );
};
